import axiosClient from './axiosClient';

export default {
  // Ricerca paginata con filtri
  search: (filters, page = 0, size = 10, sort = 'timestamp,DESC') => {
    const params = { page, size, sort };
    console.log("auditApi params",params);
    return axiosClient.post('/audit', filters, { params });
  },

  // Dettaglio singolo record audit
  get: (id) => axiosClient.get(`/audit/${id}`),
};